(function () {
  "use strict";

  document.addEventListener("init", function (e) {
    const qty = e.target.closest(".quantity:not(.hidden) .qty");
    if (qty && !qty.classList.contains("initialized")) {
      const minusBtn = document.createElement("span");
      minusBtn.className = "m-btn";
      minusBtn.innerHTML = '<i class="fi fi-br-minus"></i>';
      qty.parentNode.insertBefore(minusBtn, qty);

      const plusBtn = document.createElement("span");
      plusBtn.className = "p-btn";
      plusBtn.innerHTML = '<i class="fi fi-br-plus"></i>';
      qty.parentNode.insertBefore(plusBtn, qty.nextSibling);

      qty.closest(".quantity").classList.add("custom-num");
      qty.style.display = "block";
      qty.classList.add("initialized");
    }
  });

  document.addEventListener("click", function (e) {
    const minusBtn = e.target.closest(".quantity .m-btn");
    if (minusBtn) {
      const parent = minusBtn.parentNode;
      const input = parent ? parent.querySelector("input.qty") : null;
      if (input) {
        const minVal = input.getAttribute("min")
          ? parseInt(input.getAttribute("min"))
          : 1;
        const currentVal = parseInt(input.value) || 0;
        if (currentVal > minVal) {
          input.value = currentVal - 1;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
      return;
    }

    const plusBtn = e.target.closest(".quantity .p-btn");
    if (plusBtn) {
      const parent = plusBtn.parentNode;
      const input = parent ? parent.querySelector("input.qty") : null;
      if (input) {
        const maxVal =
          input.getAttribute("max") && input.getAttribute("max").length > 0
            ? parseInt(input.getAttribute("max"))
            : Infinity;
        const currentVal = parseInt(input.value) || 0;
        if (currentVal < maxVal || isNaN(maxVal)) {
          input.value = currentVal + 1;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
      return;
    }
  });

  const initAllQuantities = () => {
    document.querySelectorAll(".quantity .qty").forEach((qty) => {
      qty.dispatchEvent(new CustomEvent("init", { bubbles: true }));
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllQuantities);
  } else {
    initAllQuantities();
  }

  // Handle WooCommerce fragments refresh
  if (window.jQuery) {
    window.jQuery(document).ajaxSuccess(function (event, xhr, settings) {
      let req_url = settings.url;
      if (req_url.indexOf("wc-ajax=get_refreshed_fragments") > -1) {
        initAllQuantities();
      }
    });
  }

  document.addEventListener("change", function (e) {
    const $el = e.target.closest(".products-archive-tabs li input");
    if (!$el) return;
    document
      .querySelector("form.woocommerce-ordering")
      .dispatchEvent(new Event("submit", { bubbles: true }));
  });

  document.addEventListener("DOMContentLoaded", function () {
    if (window.get && window.get("stock") === "instock") {
      const checkbox = document.getElementById("archive-in-stock-switch");
      if (checkbox) checkbox.checked = true;
    }
  });

  document.addEventListener("change", function (e) {
    const switchCheckbox = e.target.closest("#archive-in-stock-switch");
    if (switchCheckbox) {
      if (document.body.classList.contains("ns-live-filter-enabled")) {
        return; // Handled by live-filter.js
      }
      if (switchCheckbox.checked) {
        window.insertParam("stock", "instock");
      } else {
        window.removeParam("stock");
      }
    }
  });

  function wpbtt_btn(i) {
    let prec = i * 3.6;
    const toTopSpan = document.querySelector("#negarshop-to-top > span");
    if (!toTopSpan) return;

    if (prec <= 180) {
      toTopSpan.style.backgroundImage =
        "linear-gradient(" +
        (prec + 90) +
        "deg, transparent 50%, #fff 50%),linear-gradient(90deg, #fff 50%, transparent 50%)";
    } else {
      toTopSpan.style.backgroundImage =
        "linear-gradient(" +
        (prec - 90) +
        "deg, transparent 50%, var(--ns-primary) 50%),linear-gradient(90deg, #fff 50%, transparent 50%)";
    }
  }

  function wpbtt_start() {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    let docHeight = document.documentElement.scrollHeight;
    let winHeight = window.innerHeight;
    let scrollPercent = scrollTop / (docHeight - winHeight);
    let scrollPercentRounded = Math.round(scrollPercent * 100);
    wpbtt_btn(scrollPercentRounded);
  }

  window.wpbtt_start = wpbtt_start;

  // Grid products load more
  document.addEventListener("click", function (e) {
    const loadMoreBtn = e.target.closest(
      ".products-grid .grid-products-loader button.btn",
    );
    if (loadMoreBtn) {
      e.preventDefault();
      let ti_offset = parseInt(loadMoreBtn.getAttribute("data-offset") || 0);
      loadMoreBtn.classList.add("disabled");

      const params = new URLSearchParams();
      params.append("action", "negarshop_grid_post_ajax");
      params.append("query", loadMoreBtn.getAttribute("data-query") || "");
      params.append("offset", ti_offset);

      fetch(NS_OBJ.ajax_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params,
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.status) {
            ti_offset++;
            loadMoreBtn.setAttribute("data-offset", ti_offset);
            loadMoreBtn.classList.remove("disabled");

            const gridItems = loadMoreBtn.closest(".grid-items");
            const row = gridItems ? gridItems.querySelector(".row") : null;
            if (row) {
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = response.data;
              while (tempDiv.firstChild) {
                row.appendChild(tempDiv.firstChild);
              }
            }
            if (!response.next) {
              loadMoreBtn.remove();
            }
          }
        })
        .catch((err) => {
          console.error(err);
          loadMoreBtn.classList.remove("disabled");
        });
      return;
    }

    // Category tree accordion toggle click
    const catLink = e.target.closest("ul.product-categories li.cat-parent>a");
    if (catLink) {
      const parentLi = catLink.closest("li");
      const isOpen = parentLi && parentLi.classList.contains("open");

      if (!isOpen) {
        e.preventDefault();
        const siblingUl = catLink.nextElementSibling;
        if (siblingUl && siblingUl.tagName === "UL") {
          siblingUl.style.display = "block";
        }
        if (parentLi) parentLi.classList.add("open");
        return;
      }
      // If it is already open, let the click event bubble for AJAX navigation
    }
  });

  // noUiSlider initialization
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof noUiSlider !== "undefined") {
      document.querySelectorAll(".styled-slider-input").forEach((el) => {
        const slider = noUiSlider.create(el, {
          start: 3,
          step: 1,
          connect: [true, false],
          direction: "rtl",
          range: {
            min: 1,
            max: 5,
          },
        });

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = el.getAttribute("data-name") || "";
        input.value = "3";
        el.appendChild(input);

        const levelText = document.createElement("span");
        levelText.className = "level";
        levelText.textContent = negarshopI18nObj.medium;
        el.appendChild(levelText);

        slider.on("slide.one", function (a) {
          input.value = parseInt(a[0]);
          switch (parseInt(a[0])) {
            case 2:
              levelText.textContent = negarshopI18nObj.bad;
              break;
            case 3:
              levelText.textContent = negarshopI18nObj.medium;
              break;
            case 4:
              levelText.textContent = negarshopI18nObj.good;
              break;
            case 5:
              levelText.textContent = negarshopI18nObj.excelent;
              break;
            default:
              levelText.textContent = negarshopI18nObj.verybad;
              break;
          }
        });
      });
    }

    // Chips input initialization
    document.querySelectorAll(".chips-input").forEach((el) => {
      const wrapper = document.createElement("div");
      wrapper.className = "chips-input";

      const addBox = document.createElement("div");
      addBox.className = "add-box";

      const input = document.createElement("input");
      input.type = "text";
      input.name = (el.getAttribute("data-name") || "") + "[]";
      input.placeholder = el.getAttribute("data-phold") || "";
      input.className = "text-field form-control";

      const addBtn = document.createElement("button");
      addBtn.className = "btn add-item";
      addBtn.type = "button";
      addBtn.innerHTML = '<i class="fi fi-br-plus"></i>';

      addBox.appendChild(input);
      addBox.appendChild(addBtn);

      const list = document.createElement("ul");
      list.className = "chip-items";

      wrapper.appendChild(addBox);
      wrapper.appendChild(list);
      el.appendChild(wrapper);
    });
  });

  // Chips input actions
  document.addEventListener("keypress", function (e) {
    const input = e.target.closest(".chips-input input.text-field");
    if (input && e.key === "Enter") {
      e.preventDefault();
      const parent = input.closest(".add-box");
      const addBtn = parent ? parent.querySelector(".add-item") : null;
      if (addBtn) addBtn.click();
    }
  });

  document.addEventListener("click", function (e) {
    const addBtn = e.target.closest(".chips-input .add-box .add-item");
    if (addBtn) {
      const parent = addBtn.closest(".chips-input[data-name]");
      const field = parent ? parent.querySelector(".text-field") : null;
      const txt_inp = field ? field.value : "";
      if (txt_inp !== "") {
        const div = document.createElement("div");
        div.innerHTML = txt_inp;

        const list = parent.querySelector(".chip-items");
        if (list) {
          const li = document.createElement("li");
          li.innerHTML =
            "<span>" +
            div.innerText +
            '</span><button class="remove-item" type="button"><i class="fi fi-sr-x"></i></button><input type="hidden" name="' +
            parent.getAttribute("data-name") +
            '[]" value="' +
            txt_inp +
            '">';
          list.insertBefore(li, list.firstChild);
        }
        if (field) field.value = "";
      }
      return;
    }

    const removeBtn = e.target.closest(".chips-input .chip-items .remove-item");
    if (removeBtn) {
      const li = removeBtn.closest("li");
      if (li) li.remove();
      return;
    }
  });

  // Native countdown.js initialization
  document.addEventListener("init", function (e) {
    const el = e.target.closest(".negarshop-countdown");
    if (el) {
      if (typeof window.countdown === "undefined") return;

      if (el.classList.contains("initialized")) return;

      if (el.countdownTimerId) {
        clearInterval(el.countdownTimerId);
      }

      let dateStr = el.getAttribute("data-date") || "0000/00/00";
      let targetDate = new Date(dateStr);

      // Cache the original HTML template to preserve placeholders for subsequent ticks
      let template = el.innerHTML.trim();
      if (!template) {
        template =
          '<span class="countdown-item countdown-item--day"><span class="item-value">{days}</span><span class="item-label">' +
          NS_OBJ.i18n.day +
          "</span></span>" +
          '<span class="countdown-item countdown-item--hour"><span class="item-value">{hours}</span><span class="item-label">' +
          NS_OBJ.i18n.hour +
          "</span></span>" +
          '<span class="countdown-item countdown-item--minute"><span class="item-value">{minutes}</span><span class="item-label">' +
          NS_OBJ.i18n.minute +
          "</span></span>" +
          '<span class="countdown-item countdown-item--second"><span class="item-value">{seconds}</span><span class="item-label">' +
          NS_OBJ.i18n.second +
          "</span></span>";
      }

      const timerId = window.countdown(
        targetDate,
        function (ts) {
          const days = String(ts.days || 0).padStart(2, "0");
          const hours = String(ts.hours || 0).padStart(2, "0");
          const minutes = String(ts.minutes || 0).padStart(2, "0");
          const seconds = String(ts.seconds || 0).padStart(2, "0");

          el.innerHTML = template
            .replace("{days}", days)
            .replace("{hours}", hours)
            .replace("{minutes}", minutes)
            .replace("{seconds}", seconds);

          const daySection = el.querySelector(".countdown-section--day");
          if (daySection) {
            daySection.style.display = (ts.days || 0) === 0 ? "none" : "";
          }
        },
        window.countdown.DAYS |
          window.countdown.HOURS |
          window.countdown.MINUTES |
          window.countdown.SECONDS,
      );
      el.countdownTimerId = timerId;
      el.classList.add("initialized");
      return;
    }
  });

  const initAllCountdowns = () => {
    document.querySelectorAll(".negarshop-countdown").forEach((el) => {
      el.dispatchEvent(new CustomEvent("init", { bubbles: true }));
    });
  };

  // Amazing Products Slider Widget width checker
  const sliderResizeObserver =
    typeof ResizeObserver !== "undefined"
      ? new ResizeObserver((entries) => {
          for (let entry of entries) {
            entry.target.dispatchEvent(
              new CustomEvent("negarshop:update-amazing-slider-size", {
                bubbles: true,
              }),
            );
          }
        })
      : null;

  document.addEventListener(
    "negarshop:update-amazing-slider-size",
    function (e) {
      const el = e.target.closest(".amazing-products-slider-widget");
      if (!el) return;

      const width = el.getBoundingClientRect().width;

      el.classList.remove(
        "amazing-products-slider-widget--small",
        "amazing-products-slider-widget--normal",
        "amazing-products-slider-widget--large",
      );

      const isTabsSide = el.classList.contains(
        "amazing-products-slider-widget--tabs-side",
      );
      let smallThreshold = 700;
      let largeThreshold = 1200;

      if (isTabsSide) {
        smallThreshold = 800;
      }

      if (width < smallThreshold) {
        el.classList.add("amazing-products-slider-widget--small");
      } else if (width < largeThreshold) {
        el.classList.add("amazing-products-slider-widget--normal");
      } else {
        el.classList.add("amazing-products-slider-widget--large");
      }
    },
  );

  const initAmazingSliderSizes = (context) => {
    (context || document)
      .querySelectorAll(".amazing-products-slider-widget")
      .forEach((el) => {
        if (sliderResizeObserver && !el.dataset.sizeObserved) {
          sliderResizeObserver.observe(el);
          el.dataset.sizeObserved = "true";
        }
        el.dispatchEvent(
          new CustomEvent("negarshop:update-amazing-slider-size", {
            bubbles: true,
          }),
        );
      });
  };

  if (!sliderResizeObserver) {
    window.addEventListener("resize", () => {
      document
        .querySelectorAll(".amazing-products-slider-widget")
        .forEach((el) => {
          el.dispatchEvent(
            new CustomEvent("negarshop:update-amazing-slider-size", {
              bubbles: true,
            }),
          );
        });
    });
  }

  const handleStoryResize = () => {
    const windowHeight = window.innerHeight;
    document
      .querySelectorAll(".widget-story .story-viewport .viewport-wrapper")
      .forEach((wrapper) => {
        const itemHeight = wrapper.offsetHeight;
        if (windowHeight < itemHeight) {
          wrapper.style.width = windowHeight / 1.77 + "px";
          const carousel = wrapper.querySelector(".view-carousel");
          if (carousel && carousel.swiperInstance) {
            carousel.swiperInstance.update();
          }
        } else {
          wrapper.style.width = "400px";
        }
      });
  };

  window.addEventListener("resize", handleStoryResize);
  window.addEventListener("showstories", handleStoryResize);

  document.addEventListener("click", function (e) {
    const slide = e.target.closest(".widget-story .story-items .swiper-slide");
    if (slide) {
      const widgetStory = slide.closest(".widget-story");
      if (widgetStory) {
        const viewport = widgetStory.querySelector(".story-viewport");
        if (viewport) {
          viewport.classList.add("show-viewport");
        }

        const carousel = widgetStory.querySelector(".view-carousel");
        if (carousel && carousel.swiperInstance) {
          const slides = Array.from(slide.parentNode.children);
          const index = slides.indexOf(slide);

          carousel.swiperInstance.slideTo(index, 0);
          if (carousel.swiperInstance.autoplay) {
            carousel.swiperInstance.params.autoplay.delay = 5000;
            carousel.swiperInstance.autoplay.start();
          }
        }

        document.body.classList.add("story-showing");
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent("showstories"));
        }, 500);
      }
      return;
    }

    const closeBtn = e.target.closest(
      ".widget-story .close-stories, .widget-story .viewport-dismisser",
    );
    if (closeBtn) {
      const widgetStory = closeBtn.closest(".widget-story");
      if (widgetStory) {
        closeWidgetStory(widgetStory);
      }
      return;
    }
  });

  function closeWidgetStory(widgetStory) {
    const viewport = widgetStory.querySelector(".story-viewport");
    if (viewport) {
      viewport.classList.remove("show-viewport");
    }
    const carousel = widgetStory.querySelector(".view-carousel");
    if (
      carousel &&
      carousel.swiperInstance &&
      carousel.swiperInstance.autoplay
    ) {
      carousel.swiperInstance.autoplay.stop();
    }
    document.body.classList.remove("story-showing");
  }

  // Live price widget: fetch value from tgju and refresh periodically
  const livePriceFetch = (el) => {
    if (!el || el.classList.contains("loading")) return;
    const target = el.getAttribute("data-target") || "";
    const symb = el.getAttribute("data-symb") || "";
    if (!target) return;

    const valPlace = el.querySelector("span");
    if (!valPlace) return;
    if (valPlace.textContent.length === 0) {
      valPlace.textContent = "بارگذاری...";
    }
    el.classList.add("loading");

    fetch("https://call3.tgju.org/ajax.json")
      .then((resp) => (resp.ok ? resp.json() : Promise.reject()))
      .then((response) => {
        if (
          !response ||
          !response.current ||
          typeof response.current[target] === "undefined"
        ) {
          valPlace.textContent = "خطا";
          return;
        }
        valPlace.textContent = response.current[target].p + " " + symb;
      })
      .catch(() => {
        valPlace.textContent = "خطا";
      })
      .finally(() => {
        setTimeout(() => el.classList.remove("loading"), 1000);
      });
  };

  document.addEventListener("click", function (e) {
    const reloadBtn = e.target.closest(".widget-negarshop-live-price .reload");
    if (reloadBtn) {
      livePriceFetch(reloadBtn.closest(".widget-negarshop-live-price"));
    }
  });

  const initAllLivePrices = () => {
    document.querySelectorAll(".widget-negarshop-live-price").forEach((el) => {
      if (el.dataset.livePriceInitialized) return;
      el.dataset.livePriceInitialized = "true";
      livePriceFetch(el);
      setInterval(() => livePriceFetch(el), 60000);
    });
  };

  const initAllWidgetsData = () => {
    initAllCountdowns();
    initAmazingSliderSizes();
    initAllLivePrices();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllWidgetsData);
  } else {
    initAllWidgetsData();
  }
})();
